/* istanbul ignore file */
import { TextField, FieldProps, useFieldHelper } from 'framework/ui/field';
import ProjectLink from './ProjectLink';
import { useAuthorization } from 'framework/authorization';

const ProjectLinkField = ({ source, nameSource, permissionToCheck, ...props }: FieldProps) => {
  const { getValue: getId } = useFieldHelper({ source });
  const { getValue: getName } = useFieldHelper({ source: nameSource });
  const { isGranted } = useAuthorization();

  const name = getName();
  const value = name ? (
    <ProjectLink isClickable={isGranted(permissionToCheck)} name={name} id={getId()} {...props} />
  ) : null;

  return <TextField value={value} {...props} />;
};

export default ProjectLinkField;
